import { cn } from '@packages/shared/src/utils/cn/cn';
import type { HTMLAttributes, ReactNode } from 'react';

export type OutlinedCardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const OutlinedCard = ({ className, children, ...props }: OutlinedCardProps) => (
  <div
    className={cn('border-color-grey items-center rounded-[8px] border p-1.5', className)}
    {...props}
  >
    {children}
  </div>
);
